import { Injectable } from '@angular/core';
import { AlloxApiService } from './allox-api.service';
import { MultiAdConfig } from '../models';
import { map } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class MultiAdConfigService {

  private path = '/multi_ad_configs';

  constructor(private http: AlloxApiService) { }

  public search() {
    return this.http.get<[]>(this.path).pipe(
      map(objs => objs.map(obj => new MultiAdConfig(obj)))
    );
  }
}
